module.exports = __webpack_public_path__ + "static/media/enterprise-1.8a3fbfaa.jpg";